module.exports = __webpack_public_path__ + "static/media/test1.597e505d.jpeg";